import React, { Component, memo } from 'react';

import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withTranslation } from 'react-i18next';
import { toastr } from 'react-redux-toastr';
import { IaCreators } from '../../../../store/actions/intelligence';
import { BotsCreators } from '../../../../store/actions/bots';

import fechar from '../../img/fechar.svg';
import edit from '../../img/edit_create.svg';
import deleteC from '../../img/icon_delete_create.svg';
import './index.scss';
import pontilhado from '../../img/pontilhado.svg';
import CirclePoint from '../CirclePoint/CirclePoint';
import { UserActions } from '../../../../store/actions/users';

class EditIntelligenceCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nome: '',
      userItem: [],
      text: '',
      isFrase: false,
      userEntity: {},
      synonyms: [],
      objects: [],
      entidade: '',
      nameObj: '',
      sinonimo: '',
      edit: false,
      updatedEntIndex: -1,
    };
    this.onChangItem = this.onChangItem.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmitEntity = this.handleSubmitEntity.bind(this);
    this.addSynonyms = this.addSynonyms.bind(this);
  }

  onChang = (e) => {
    this.setState({
      nome: e.target.value,
    });
  };

  onChangItem = (e) => {
    this.setState({
      text: e.target.value,
    });
  };

  onChangObj = (e) => {
    this.setState({
      nameObj: e.target.value,
    });
  };

  onChangSin = (e) => {
    this.setState({
      sinonimo: e.target.value,
    });
  };

  componentDidMount() {
    const { blt, bot, label, listSamplesIntent, listEntity } = this.props;

    if (blt === 'intencoes') {
      listSamplesIntent(bot.currentTokenIa, 'intent', label);
    } else if (blt === 'entidades') {
      listEntity(bot.currentTokenIa, label);
    }
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.samplesAll !== this.props.samplesAll) {
      this.setState((state) => ({
        userItem: state.userItem.concat(this.props.samplesAll),
        text: '',
      }));
    } else if (prevProps.entity !== this.props.entity) {
      this.setState({
        objects: this.props.entity.objects,
        text: '',
      });
    }
  };

  handleSubmitEntity = async (e) => {
    e.preventDefault();

    await this.addObj();

    const { reference } = this.props.entity;

    if (this.state.nameObj !== '' && this.state.synonyms.length > 0) {
      const newItem = {
        entidade: this.props.label,
        objects: this.state.objects,
      };
      await this.setState({
        userEntity: newItem,
        nameObj: '',
        sinonimo: '',
        synonyms: [],
        edit: false,
      });
    } else if (this.state.nameObj === '') {
      toastr.error('Erro', 'Objeto não pode ser vazio');
    } else if (this.state.synonyms.length === 0) {
      toastr.error('Erro', 'sinônimo não pode ser vazia');
    }
    if (JSON.stringify(this.state.userEntity) !== '{}') {
      console.log(`handleSubmitEntity -> start -> reference: ${reference}`);
      await this.props.createEntities(
        this.props.bot.currentTokenIa,
        this.state.userEntity.entidade,
        this.state.userEntity.objects,
        reference
      );
    }
  };

  addObj = () => {
    if (
      this.state.nameObj !== '' &&
      this.state.synonyms.length > 0 &&
      this.state.edit === false
    ) {
      const newObj = [
        {
          name: this.state.nameObj,
          synonyms: this.state.synonyms,
        },
      ];
      this.setState({
        objects: this.state.objects.concat(newObj),
      });
    } else if (this.state.edit === true) {
      this.setState({
        objects: this.state.objects.map((obj) => {
          return obj.name === this.state.nameObj
            ? {
                reference: this.state.reference,
                name: this.state.nameObj,
                synonyms: this.state.synonyms,
              }
            : obj;
        }),
      });
    } else {
      toastr.error('Erro', 'Não pode adicionar um objeto vazio');
    }
  };

  addSynonyms(e) {
    e.preventDefault();
    if (this.state.sinonimo !== '') {
      const newSynonyms = [this.state.sinonimo];
      this.setState((state) => ({
        synonyms: state.synonyms.concat(newSynonyms),
        sinonimo: '',
      }));
    } else {
      toastr.error('Erro', 'Não pode adicionar um sinônimo vazio');
    }
  }

  editSyn(ob) {
    this.setState({
      nameObj: ob.name,
      synonyms: ob.synonyms,
      edit: true,
    });
  }

  deleteSynonyms(item) {
    const { synonyms, nameObj, edit } = this.state;
    const { deleteEntitiesSyn, bot, label } = this.props;
    const { reference } = this.props.entity;
    if (edit === true) {
      console.log(`deleteSynonyms - reference: ${reference}`);
      deleteEntitiesSyn(bot.currentTokenIa, label, nameObj, item, reference);
    }
    this.setState({
      synonyms: synonyms.filter((element) => element !== item),
    });
  }

  deleteObj(name) {
    const { objects } = this.state;
    console.log(objects);
    const index = objects.findIndex((item) => item.name === name);

    if (index >= 0) {
      console.log(`chamando o apagar entity object: ${index}`);
      this.props.deleteEntitiesObj(
        this.props.bot.currentTokenIa,
        this.props.label,
        name,
        this.props.entity?.reference,
        index
      );
      this.setState({
        objects: objects.filter((element) => element.name !== name),
      });
    } else {
      toastr.error(`Ocorreu um erro ao deletar o item`);
    }
  }

  async handleSubmit(e) {
    const { bot, label } = this.props;
    e.preventDefault();
    if (this.state.text.length === 0) {
      return;
    }

    const newItem = {
      sentence: this.state.text,
    };
    const hasEqual = this.state.userItem.find(
      (item) => item.sentence === newItem.sentence
    );

    if (this.state.updatedEntIndex !== -1 || hasEqual) {
      const { userItem } = this.state;
      const oldUserItem = userItem.find((item, index) => {
        if (!hasEqual) {
          return index === this.state.updatedEntIndex ?? item;
        }
        return this.state.text === item.sentence ?? item;
      });
      const newUserItem = userItem.map((item, index) => {
        if (!hasEqual) {
          return index === this.state.updatedEntIndex ? newItem : item;
        }
        return this.state.text === item.sentence ? newItem : item;
      });

      const { sentence } = oldUserItem;
      await this.deleteItem(sentence);

      this.setState({ userItem: newUserItem, text: '', updatedEntIndex: -1 });
    } else {
      this.setState((state) => ({
        userItem: state.userItem.concat(newItem),
        text: '',
        isFrase: true,
      }));
    }

    this.props.createSamples(bot.currentTokenIa, newItem.sentence, [
      { name: label },
    ]);
  }

  editItem = async (item) => {
    const { userItem } = this.state;
    const updatedEntIndex = userItem.indexOf(item);
    this.setState(() => ({ updatedEntIndex }));
    if (updatedEntIndex !== -1) {
      const { sentence: text } = this.state.userItem[updatedEntIndex];
      this.setState({ text });
    }
  };

  deleteItem = async (item) => {
    const { userItem } = this.state;
    const { bot, deleteSamples } = this.props;

    deleteSamples(this.props.label, bot.currentTokenIa, 'sentence', item);

    await this.setState({
      userItem: userItem.filter((element) => element.sentence !== item),
    });

    if (this.state.userItem.length === 0) {
      await this.setState({
        isFrase: false,
      });
    }
  };

  addIntent = async () => {
    const { nome } = this.state;
    const { createIntents, newCard, bot } = this.props;

    if (nome !== '') {
      await createIntents(bot.currentTokenIa, nome, this.state.userItem);
      await newCard();
    } else {
      toastr.error('Erro', 'Nome da intenção não pode ser vazia ');
    }
  };

  expectAnAction = () => {
    const { label, newCard, bot, deleteIntents, blt } = this.props;

    if (this.state.userItem.length === 0 && blt === 'intencoes') {
      deleteIntents(bot.currentTokenIa, label);
    }
    newCard();
  };

  render() {
    const { blt, label, user } = this.props;
    const { userItem, nameObj, sinonimo, objects } = this.state;

    return (
      <div>
        <div className="container-card-buttons">
          <button
            type="button"
            style={{ backgroundColor: '#0D84FF', color: 'white' }}
            onClick={this.expectAnAction}
          >
            Voltar
          </button>
        </div>
        <div className="mod-create">
          <p>{blt === 'intencoes' ? 'Intenção' : 'Entidade'}</p>
          <div className="container-input-card">
            <span>nome da {blt === 'intencoes' ? 'intenção' : 'entidade'}</span>
            <input
              disabled={user?.selectedCompany?.claim?.name === 'Viewer'}
              placeholder={blt === 'intencoes' ? 'intenção' : 'entidade'}
              onChange={this.onChang}
              value={label}
            />
          </div>
          <div className="cont-circle-mod">
            <p style={{ marginRight: 10 }}>
              {blt === 'intencoes' ? 'Exemplo' : 'Objeto'}
            </p>
            {blt === 'intencoes' && <CirclePoint item={userItem.length} />}
          </div>
          {blt === 'intencoes' ? (
            <span>
              Crie exemplos de frase de usuário para aperfeiçoar a IA, quanto
              mais, melhor!{' '}
              <span style={{ color: '#008DFA' }}>
                Aperte enter para criar novas.
              </span>
            </span>
          ) : (
            <span>
              Objeto são os itens pertencentes ao grupo, por exemplo: entidade=
              cores, obj. = azul, amarelo, vermelho.
            </span>
          )}

          <div className="container-obj-sin">
            {blt === 'intencoes' ? (
              <form className="container-obj-sin">
                <input
                  disabled={user?.selectedCompany?.claim?.name === 'Viewer'}
                  className="input-redond-int"
                  placeholder="exemplo de frase de usuário"
                  maxLength="280"
                  onChange={
                    user?.selectedCompany?.claim?.name !== 'Viewer'
                      ? this.onChangItem
                      : ''
                  }
                  value={this.state.text}
                />
                <button
                  type="button"
                  disabled={user?.selectedCompany?.claim?.name === 'Viewer'}
                  onClick={
                    user?.selectedCompany?.claim?.name !== 'Viewer'
                      ? this.handleSubmit
                      : ''
                  }
                  className="btn-adicionar"
                >
                  adicionar
                </button>
              </form>
            ) : (
              <div>
                <div className="container-obj-sin">
                  <input
                    disabled={user?.selectedCompany?.claim?.name === 'Viewer'}
                    placeholder="objeto"
                    style={{ width: 250 }}
                    disabled={this.state.edit}
                    onChange={this.onChangObj}
                    value={nameObj}
                  />
                  <div className="container-ipt-sin" style={{ width: 337 }}>
                    <input
                      disabled={user?.selectedCompany?.claim?.name === 'Viewer'}
                      placeholder="sinônimo"
                      onChange={this.onChangSin}
                      value={sinonimo}
                    />
                  </div>
                  <span
                    className="btn-adicionar"
                    onClick={
                      user?.selectedCompany?.claim?.name !== 'Viewer'
                        ? this.addSynonyms
                        : ''
                    }
                  >
                    adicionar
                  </span>
                </div>
                <div className="container-syn">
                  {this.state.synonyms.map((syn) => (
                    <div className="spn-syn">
                      {syn}
                      <img
                        alt=""
                        onClick={() => this.deleteSynonyms(syn)}
                        src={fechar}
                      />
                    </div>
                  ))}
                </div>
                <div className="container-btn-adicionar">
                  <button
                    type="button"
                    disabled={user?.selectedCompany?.claim?.name === 'Viewer'}
                    onClick={this.handleSubmitEntity}
                  >
                    {this.state.edit === true ? 'Salvar' : 'Criar objetos'}
                  </button>
                </div>
              </div>
            )}
          </div>
          {this.state.userItem.length === 0 && blt === 'intencoes' ? (
            <div style={{ marginTop: 20, color: 'rgb(241, 95, 82)' }}>
              Se não estiver nenhum exemplo de frase criada, a intenção será
              deletada
            </div>
          ) : (
            ''
          )}
          {this.state.isFrase === true && (
            <div style={{ marginTop: 20, color: 'rgb(241, 95, 82)' }}>
              Frases criadas serão treinadas
            </div>
          )}
          <p style={{ marginTop: 18 }}>
            {blt === 'intencoes' ? 'Exemplos' : 'Objetos'} Criados (
            {blt === 'intencoes' ? this.state.userItem.length : objects.length}){' '}
            {blt != 'intencoes' && <img src={pontilhado} />}
          </p>
          <div className="container-objt-criados">
            {userItem.map((sentence) => (
              <div className="container-exemplos-criados">
                <div
                  className={
                    blt === 'intencoes' ? 'exemplos-criados' : 'objetos-criados'
                  }
                >
                  <p>{sentence.sentence}</p>
                </div>
                <div className="cont-img-ent">
                  <img
                    alt=""
                    src={edit}
                    onClick={
                      user?.selectedCompany?.claim?.name !== 'Viewer'
                        ? () => this.editItem(sentence)
                        : ''
                    }
                    style={{ cursor: 'pointer' }}
                  />
                  <img
                    alt=""
                    onClick={() =>
                      user?.selectedCompany?.claim?.name !== 'Viewer'
                        ? () => this.deleteItem(sentence.sentence)
                        : ''
                    }
                    src={deleteC}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            ))}
          </div>
          <div className="container-map-entity">
            {objects?.map((ob) => (
              <div className="container-entity-obj">
                <div className="area-entity-obj">
                  <div style={{ display: 'flex' }}>
                    <span>{ob.name}</span>:
                    {ob.synonyms.map((syn) => (
                      <div style={{ display: 'flex' }}>
                        <span className="spn-syn-margin">{syn}</span>;
                      </div>
                    ))}
                  </div>
                </div>
                <div className="edit-and-delete-obj">
                  <img
                    alt=""
                    src={edit}
                    style={{ cursor: 'pointer' }}
                    onClick={
                      user?.selectedCompany?.claim?.name !== 'Viewer'
                        ? () => this.editSyn(ob)
                        : ''
                    }
                  />
                  <img
                    alt=""
                    onClick={
                      user?.selectedCompany?.claim?.name !== 'Viewer'
                        ? () => this.deleteObj(ob.name)
                        : ''
                    }
                    src={deleteC}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  samples: state.intelligence.samples,
  samplesAll: state.intelligence.samplesAll,
  entity: state.intelligence.entity,
  bot: state.bots.bot,
  user: state.users.signedUser,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...IaCreators,
      ...BotsCreators,
      ...UserActions,
    },
    dispatch
  );

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(memo(EditIntelligenceCard)))
);
